import React from 'react';
import { Badge, IconButton, Tooltip } from '@mui/material';
import ChatIcon from '@mui/icons-material/Chat';
import { useChat } from '../contexts/ChatContext';

const HeaderChatButton: React.FC = () => {
  const { state, openWidget } = useChat();

  return (
    <Tooltip title="Messagerie">
      <IconButton
        color="inherit"
        size="large"
        onClick={openWidget}
        data-chat-toggle
      >
        <Badge badgeContent={state.unreadCount} color="error" max={99}>
          <ChatIcon />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};

export default HeaderChatButton;
